import SectionMessage from '@atlaskit/section-message';
import React from 'react';

import { getIframeUrlParameterByName } from '../utils/utils';
import { useJiraContext } from './JiraContextProvider';

interface LicenseCheckerProps {
  children: React.ReactNode;
}

export function LicenseChecker({ children }: LicenseCheckerProps) {
  const isLicenseValid = getIframeUrlParameterByName('lic') === 'active';
  const { baseUrl } = useJiraContext();
  const umpLink = `${baseUrl}/plugins/servlet/upm#manage/toggl`;

  if (isLicenseValid || import.meta.env.DEV) {
    return <>{children}</>;
  } else {
    return (
      <SectionMessage appearance="error" title="Invalid license">
        <div>
          We can’t validate your Toggl for JIRA Cloud app license. Please check
          <a href={umpLink} target="_top">
            <strong> Manage apps </strong>
          </a>
          screen if the license key is correct. <br />
          If you do not have a license yet you can buy one or start a free 30
          day trial. <br />
          <br />
        </div>
      </SectionMessage>
    );
  }
}
